import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import CertificadoForm from './components/CertificadoForm';

const Certificado = (props) => {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Certificado</h3>
          <h3 className="page-subhead subhead">
            Adicione um novo certificado ou altere suas configurações
          </h3>
        </Col>
      </Row>
      <Row>
        <CertificadoForm isHorizontal={false} isAboveError props={props} />
      </Row>
    </Container>
  );
};

export default Certificado;
